import { FormArray, UntypedFormControl, UntypedFormGroup, AbstractControl, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';

export class FormValidations {
	private static DDDList = [
		'11',
		'12',
		'13',
		'14',
		'15',
		'16',
		'17',
		'18',
		'19',
		'21',
		'22',
		'24',
		'27',
		'28',
		'31',
		'32',
		'33',
		'34',
		'35',
		'37',
		'38',
		'41',
		'42',
		'43',
		'44',
		'45',
		'46',
		'47',
		'48',
		'49',
		'51',
		'53',
		'54',
		'55',
		'61',
		'62',
		'63',
		'64',
		'65',
		'66',
		'67',
		'68',
		'69',
		'71',
		'73',
		'74',
		'75',
		'77',
		'79',
		'81',
		'82',
		'83',
		'84',
		'85',
		'86',
		'87',
		'88',
		'89',
		'91',
		'92',
		'93',
		'94',
		'95',
		'96',
		'97',
		'98',
		'99',
	];

	public static checkPasswords(group: UntypedFormGroup): null | { notSame: boolean } {
		// here we have the 'passwords' group
		const pass = group.get('password')!.value;
		const confirmPass = group.get('confirmPassWord')!.value;

		return pass === confirmPass ? null : { notSame: true };
	}

	public static sameMailCheck(confirmEmailInput: string): (control: AbstractControl) => Validators {
		let confirmEmailControl: AbstractControl;
		let emailControl: AbstractControl;

		return (control: AbstractControl): Validators => {
			if (!control.parent) {
				return '';
			}

			if (!confirmEmailControl) {
				confirmEmailControl = control;
				emailControl = control?.parent?.get(confirmEmailInput) as AbstractControl;
				emailControl?.valueChanges.subscribe(() => {
					confirmEmailControl?.updateValueAndValidity();
				});
			}

			if (emailControl?.value != null && confirmEmailControl?.value != null && emailControl.value.toLocaleLowerCase() !== confirmEmailControl.value.toLocaleLowerCase()) {
				return {
					notMatch: true,
				};
			}
			return '';
		};
	}

	public static samePassCheck(confirmEmailInput: string): (control: AbstractControl) => Validators {
		let confirmPassControl: AbstractControl;
		let passControl: AbstractControl;

		return (control: AbstractControl): Validators => {
			if (!control.parent) {
				return '';
			}

			if (!confirmPassControl) {
				confirmPassControl = control;
				passControl = control.parent.get(confirmEmailInput) as AbstractControl;
				passControl.valueChanges.subscribe(() => {
					confirmPassControl.updateValueAndValidity();
				});
			}

			if (passControl.value != null && confirmPassControl.value != null && passControl.value.toLocaleLowerCase() !== confirmPassControl.value.toLocaleLowerCase()) {
				return {
					notMatch: true,
				};
			}
			return '';
		};
	}

	public static checkCellphone(cellphoneInput: UntypedFormControl): null | { cellphone: { valid: boolean } } {
		if (!cellphoneInput.value)
			return {
				cellphone: {
					valid: false,
				},
			};

		// const cellphoneInputDDD = cellphoneInput.value.substring(0, 2);
		const checkIfCel = new RegExp('^d{10}$');

		// if (!FormValidations.DDDList.includes(cellphoneInputDDD)) {
		// 	return {
		// 		cellphone: {
		// 			valid: false,
		// 		},
		// 	};
		// }

		return checkIfCel.test(cellphoneInput.value)
			? {
					cellphone: {
						valid: false,
					},
				}
			: null;
	}

	public static checkTelephone(telephoneInput: UntypedFormControl): null | { phone: { valid: boolean } } {
		if (!telephoneInput.value)
			return {
				phone: {
					valid: false,
				},
			};

		const telephoneInputDDD = telephoneInput.value.substring(0, 2);
		const checkIfTel = new RegExp('^[1-9]{2}\\d{8}$');

		if (!FormValidations.DDDList.includes(telephoneInputDDD)) {
			return {
				phone: {
					valid: false,
				},
			};
		}

		return checkIfTel.test(telephoneInput.value)
			? null
			: {
					phone: {
						valid: false,
					},
				};
	}

	public static checkCorrectName(nameInput: UntypedFormControl): null | { name: { valid: boolean } } {
		if (!nameInput.value || nameInput.value.length > 200)
			return {
				name: {
					valid: false,
				},
			};

		const checkIfNameIsCorrect = new RegExp('^[A-ZÀ-Ú][a-zà-ú]{2,}(?: ([A-ZÀ-Ú]|[a-zà-ú])[a-zà-ú]*)+\\s*$');

		return checkIfNameIsCorrect.test(nameInput.value)
			? null
			: {
					name: {
						valid: false,
					},
				};
	}

	public static minDateValidator(minDate: Date): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (!control.value) return null;
			const [day, month, year] = control.value?.split('/');
			const result = [year, month, day]?.join('-');
			const date = new Date(result);
			if (minDate.getTime() < date.getTime()) {
				return null;
			} else {
				return { min: { value: control.value, expected: minDate } };
			}
		};
	}
}
